import { get } from 'lodash'

export default function(data) {
  return {
    birthDate: get(data, 'birthDate'),
    phone: get(data, 'phone'),
    secondaryPhone: get(data, 'secondaryPhone'),
    secondaryEmail: get(data, 'secondaryEmail'),
    assessorDetail: {
      childProtectionNumber: get(data, 'assessorDetail.childProtectionNumber'),
      childProtectionExpirationDate: get(
        data,
        'assessorDetail.childProtectionExpirationDate'
      )
    }
  }
}
